/* ELEMENT — BLACK FRIDAY 2026 FREE SOFTENER PICKER
   Adds the chosen softener with a _element_gift property, then checks the cart:
   Shopify's automatic Buy X Get Y ("Black Friday — free softener with £19.99") must have
   taken a softener line to £0.00. If it did not, the customer is told here, not at checkout.
   Binds in connectedCallback so it survives Prestige's Section Rendering refresh of the drawer. */
(function () {
  'use strict';
  if (customElements.get('efm-bf-gift')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MONEY = function (pence) { return '£' + (pence / 100).toFixed(2); };

  var emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var payload = { event: name };
      for (var k in detail) { if (Object.prototype.hasOwnProperty.call(detail, k)) payload[k] = detail[k]; }
      window.dataLayer.push(payload);
    }
  };

  class EfmBfGift extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-efm-gift-add]'));
      this.errorEl = this.querySelector('[data-efm-gift-error]');
      this.onClick = this.onClick.bind(this);
      this.buttons.forEach(function (b) { b.addEventListener('click', this.onClick); }, this);
      emit('element:bf_gift_shown', { state: this.dataset.state });
    }

    disconnectedCallback() {
      this.buttons.forEach(function (b) { b.removeEventListener('click', this.onClick); }, this);
    }

    setBusy(isBusy, active) {
      this.buttons.forEach(function (b) {
        b.disabled = isBusy || b.getAttribute('data-sold-out') === 'true';
        var label = b.querySelector('[data-efm-gift-label]');
        if (label && b === active) label.textContent = isBusy ? 'Adding' : 'Add free';
      });
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    onClick(event) {
      var self = this;
      var button = event.currentTarget;
      var variantId = button.getAttribute('data-variant-id');
      var scent = button.getAttribute('data-scent');
      if (!variantId || button.disabled) return;
      this.setBusy(true, button);
      if (this.errorEl) this.errorEl.hidden = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _element_gift: 'bf26' } }] })
      })
      .then(function (res) {
        if (!res.ok) { return res.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add that just now.'); }); }
        return res.json();
      })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        /* Shopify picks which eligible softener the gift lands on (it may be a bottle that was
           already in the basket), so the check is "did the gift discount land on any softener",
           not "is the line we added free". */
        var giftLanded = false;
        var line = null;
        (cart.items || []).forEach(function (item) {
          (item.line_level_discount_allocations || []).forEach(function (a) {
            var t = ((a.discount_application && a.discount_application.title) || '').toLowerCase();
            if (t.indexOf('free softener') !== -1 && a.amount > 0) giftLanded = true;
          });
          if (!line && String(item.variant_id) === String(variantId) && item.properties && item.properties._element_gift === 'bf26') line = item;
        });
        var paid = line ? Math.round(line.final_line_price / line.quantity) : null;
        if (!giftLanded) {
          self.showError('Added, but at ' + (paid === null ? 'full price' : MONEY(paid)) + '. The free-softener offer did not apply: a discount code in use, or under £19.99 of qualifying items. Remove the code or the bottle.');
          emit('element:bf_gift_not_free', { variant_id: variantId, scent: scent, paid: paid });
        } else {
          emit('element:bf_gift_added', { variant_id: variantId, scent: scent, cart_total_after: cart.total_price });
        }
        self.refreshCart(cart);
      })
      .catch(function (e) {
        self.setBusy(false, button);
        self.showError((e && e.message) || 'Something went wrong. Please try again.');
        emit('element:bf_gift_failed', { reason: String(e && e.message) });
      });
    }

    refreshCart(cart) {
      var self = this;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'efm-bf-gift', cart: cart }); } catch (e) {}
      }
      setTimeout(function () { if (self.isConnected) window.location.reload(); }, 1200);
    }
  }

  customElements.define('efm-bf-gift', EfmBfGift);
})();
